module.exports = __webpack_public_path__ + "img/地热国4_1.d384404e.png";